import { toString as toString_1, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Company, Department, Department_$reflection, CompanyForm_$reflection, CompanyForm, Company_$reflection } from "../Shared/ApiDataTypes.js";
import { unit_type, obj_type, union_type, record_type, string_type, bool_type, option_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { sortBy, map as map_1, append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { some, defaultArg, bind, unwrap, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Skeleton, TableContainer, Table, TableBody, TableHead, Box, Collapse, TableCell, TableRow, Checkbox, DialogContentText, Typography, IconButton, DialogActions, Button, DialogContent, TextField, DialogTitle, Dialog } from "@mui/material";
import { comparePrimitives, uncurry2, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Company_validateAbbr } from "../Shared/Shared.js";
import { loadingIndicator as loadingIndicator_1, SnackError, loadingIndicatorSmall, errorBanner } from "../ViewHelpers.js";
import { cons, empty, singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { empty as empty_1, append as append_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { generateQueryString, API_Company_Department, API_Company_Company } from "../Shared/Urls.js";
import Save from "@mui/icons-material/Save";
import Close from "@mui/icons-material/Close";
import Add from "@mui/icons-material/Add";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { useResponsive } from "../Utils.js";
import { Company_fetchCompanies } from "../Promises.js";

class Model extends Record {
    constructor(Companies, AddForm, ErrorMsg) {
        super();
        this.Companies = Companies;
        this.AddForm = AddForm;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Departments.Model", [], Model, () => [["Companies", option_type(array_type(Company_$reflection()))], ["AddForm", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DepartmentAdded", "DepartmentsResponse", "ToggleAddForm", "UpdateDepartment", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Departments.Message", [], Message, () => [[["Item", Company_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Company_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Company_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", bool_type]], [["Item", Company_$reflection()]], []]);
}

function init() {
    return new Model(undefined, false, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 2:
            return new Model(model.Companies, msg.fields[0], model.ErrorMsg);
        case 0: {
            const x_2 = msg.fields[0];
            const matchValue = model.Companies;
            if (matchValue != null) {
                return new Model(append([x_2], matchValue), false, model.ErrorMsg);
            }
            else {
                return new Model([x_2], false, model.ErrorMsg);
            }
        }
        case 3: {
            const updatedDep = msg.fields[0];
            return new Model(map((array_2) => map_1((dep) => {
                if (dep.Id === updatedDep.Id) {
                    return updatedDep;
                }
                else {
                    return dep;
                }
            }, array_2), model.Companies), model.AddForm, model.ErrorMsg);
        }
        case 4:
            return new Model(model.Companies, model.AddForm, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return model;
            }
            else {
                return new Model(res.fields[0], model.AddForm, model.ErrorMsg);
            }
        }
    }
}

function AddForm(addFormInputProps) {
    let elements_2, children, elems, children_1;
    const onClose = addFormInputProps.onClose;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState("");
    const database = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    let patternInput_2;
    const initial_2 = {
        Text: "",
    };
    patternInput_2 = reactApi.useState(initial_2);
    const updateAbbr = patternInput_2[1];
    const abbr = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setProcessing = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setErrMsg = patternInput_4[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Companies.AddCompany")]]), (children = singleton(createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
        marginTop: 5,
    }], (elems = [MuiHelpers_createElement(TextField, [["defaultValue", name], ["onChange", (e) => {
        patternInput_1[1](e.target.value);
    }], ["variant", "outlined"], ["label", ctx.Locale.t("Account.Name")], ["autoFocus", true]]), MuiHelpers_createElement(TextField, [["onBlur", (_arg_5) => {
        if (abbr.Error == null) {
            updateAbbr({
                Error: unwrap(Company_validateAbbr(ctx.Language, abbr.Text)),
                Text: abbr.Text,
            });
        }
    }], ["label", ctx.Locale.t("Companies.Abbr")], ["defaultValue", abbr.Text], ["onChange", (e_1) => {
        const txt = e_1.target.value;
        updateAbbr({
            Error: unwrap(bind((_arg_6) => undefined, abbr.Error)),
            Text: txt,
        });
    }], ["error", abbr.Error != null], ["helperText", defaultArg(abbr.Error, "")], ["variant", "outlined"]]), MuiHelpers_createElement(TextField, [["label", "Database"], ["defaultValue", database], ["onChange", (e_2) => {
        patternInput[1](e_2.target.value);
    }], ["variant", "outlined"]]), errorBanner(patternInput_4[0], () => {
        setErrMsg(undefined);
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput_3[0] ? singleton_1(loadingIndicatorSmall()) : append_1(singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["color", "primary"], ["children", ctx.Locale.t("Close")], ["onClick", (_arg_8) => {
        onClose(undefined);
    }]])), delay(() => singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["disabled", ((name.trim().length === 0) ? true : (database.trim().length === 0)) ? true : (abbr.Error != null)], ["children", ctx.Locale.t("Add")], ["onClick", (_arg_9) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let body, decoder, data_1, caseStrategy_3, extra_3;
            setProcessing(true);
            const req = new CompanyForm(name.trim(), database.trim(), abbr.Text.trim());
            return ((body = Auto_generateBoxedEncoder_437914C6(CompanyForm_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(Company_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/company", properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Company_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })())))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 1) {
                    setProcessing(false);
                    setErrMsg("Kunne ikke legge til avdeling. Vennglist prøv igjen senere");
                    return Promise.resolve();
                }
                else {
                    onClose(res.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function AbbrUpdateButton(abbrUpdateButtonInputProps) {
    const onUpdate = abbrUpdateButtonInputProps.onUpdate;
    const company = abbrUpdateButtonInputProps.company;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setEditing = patternInput[1];
    const patternInput_1 = reactApi.useState(company.Abbr);
    const abbr = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setProcessing = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setError = patternInput_3[1];
    const xs_2 = toList(delay(() => append_1(singleton_1(createElement(SnackError, {
        errMsg: unwrap(patternInput_3[0]),
        dismiss: () => {
            setError(undefined);
        },
    })), delay(() => {
        let elems_3, elems_2, elements, elements_1, props_5, elements_2, props_11;
        return patternInput[0] ? singleton_1(createElement("div", createObj(ofArray([["style", {
            maxWidth: 30 + "ch",
        }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
        }], (elems_2 = [MuiHelpers_createElement(TextField, [["style", {
            maxWidth: 15 + "ch",
        }], ["label", ctx.Locale.t("Companies.Abbr")], ["size", "small"], ["variant", "outlined"], ["onChange", (e) => {
            patternInput_1[1](e.target.value);
        }]]), MuiHelpers_createElement(IconButton, [["onClick", (_arg_2) => {
            let properties_2;
            setProcessing(true);
            const url = API_Company_Company(company.Id);
            const abbrError = Company_validateAbbr(ctx.Language, abbr);
            if (abbrError == null) {
                let pr_1;
                const item = new CompanyForm(company.Name, company.Database, abbr.trim());
                const data = some(Auto_generateBoxedEncoder_437914C6(CompanyForm_$reflection(), undefined, undefined, undefined)(item));
                const decoder = Auto_generateBoxedDecoder_Z6670B51(Company_$reflection(), undefined, undefined);
                const data_1 = data;
                const caseStrategy_3 = undefined;
                const extra_3 = undefined;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Company_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
                }
                catch (exn) {
                    pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
                pr_1.then((updatedDepRes) => {
                    if (updatedDepRes.tag === 0) {
                        const updatedDep = updatedDepRes.fields[0];
                        console.debug("Updated company:", updatedDep);
                        onUpdate(updatedDep);
                        setError(undefined);
                    }
                    else {
                        console.error(some("Could not update company:"), updatedDepRes.fields[0]);
                        setError(ctx.Locale.t("Companies.UpdateError"));
                    }
                    setProcessing(false);
                });
            }
            else {
                const err = abbrError;
                console.error(some(`The new company abbrv. is invalid: '${abbr}'`));
                setError(err);
                setProcessing(false);
            }
        }], ["size", "small"], (elements = toList(delay(() => {
            let props_2;
            return patternInput_2[0] ? singleton_1(loadingIndicatorSmall()) : singleton_1((props_2 = {}, react.createElement(Save, props_2)));
        })), ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(IconButton, [["onClick", (_arg_3) => {
            setEditing(false);
        }], ["size", "small"], (elements_1 = [(props_5 = {}, react.createElement(Close, props_5))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), MuiHelpers_createElement(Typography, [["variant", "caption"], ["children", ctx.Locale.t("Companies.AbbrMissing")]])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : singleton_1(MuiHelpers_createElement(IconButton, [["onClick", (_arg_4) => {
            setEditing(true);
        }], ["size", "small"], (elements_2 = [(props_11 = {}, react.createElement(Add, props_11))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function DisableDepartmentButton(disableDepartmentButtonInputProps) {
    let elements;
    const newEnabled = disableDepartmentButtonInputProps.newEnabled;
    const onUpdate = disableDepartmentButtonInputProps.onUpdate;
    const departmentId = disableDepartmentButtonInputProps.departmentId;
    const companyId = disableDepartmentButtonInputProps.companyId;
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const buttonText = newEnabled ? "Aktiver" : "Deaktiver";
    if (patternInput[0]) {
        return MuiHelpers_createElement(Button, [["variant", "outlined"], (elements = [loadingIndicator_1()], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    }
    else {
        return createElement(Components_Button_Z1043B8E, {
            text: buttonText,
            onClick: (ev) => {
                let properties_2;
                const url = API_Company_Department(companyId, departmentId) + generateQueryString([["enabled", toString_1(newEnabled)]]);
                setLoading(true);
                let pr_1;
                const data = some(Auto_generateBoxedEncoder_437914C6(unit_type, undefined, undefined, undefined)());
                const decoder = Auto_generateBoxedDecoder_Z6670B51(Department_$reflection(), undefined, undefined);
                const data_1 = data;
                const caseStrategy_3 = undefined;
                const extra_3 = undefined;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Department_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
                }
                catch (exn) {
                    pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
                pr_1.then((res) => {
                    if (res.tag === 0) {
                        const updated = res.fields[0];
                        console.info(some("[Departments] Success: %o"), updated);
                        onUpdate(updated);
                    }
                    else {
                        console.error(some("[Departments] Error updating: %o"), res.fields[0]);
                    }
                    setLoading(false);
                });
            },
            small: true,
            color: "green",
        });
    }
}

function EnableCheckboxDialog(enableCheckboxDialogInputProps) {
    let elements_2, elements, children;
    const enabled = enableCheckboxDialogInputProps.enabled;
    const onChange = enableCheckboxDialogInputProps.onChange;
    const departmentId = enableCheckboxDialogInputProps.departmentId;
    const companyId = enableCheckboxDialogInputProps.companyId;
    const patternInput = reactApi.useState(false);
    const setDialogOpen = patternInput[1];
    const xs = [MuiHelpers_createElement(Dialog, [["open", patternInput[0]], ["onClose", (_arg, v) => {
        setDialogOpen(false);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", enabled ? "Deaktivere avdeling" : "Aktiver avdeling"]]), MuiHelpers_createElement(DialogContent, [(elements = [MuiHelpers_createElement(DialogContentText, [["children", enabled ? "Er du sikker på at du vil deaktivere denne avdelingen?" : "Er du sikker på at du vil aktivere denne avdelingen?"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), (children = ofArray([createElement(Components_Button_Z1043B8E, {
        text: "Avbryt",
        onClick: (ev) => {
            setDialogOpen(false);
        },
        small: true,
        color: "gray",
    }), createElement(DisableDepartmentButton, {
        companyId: companyId,
        departmentId: departmentId,
        onUpdate: (updated) => {
            onChange(updated.Enabled);
        },
        newEnabled: !enabled,
    })]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]), MuiHelpers_createElement(Checkbox, [["checked", enabled], ["onChange", (e) => {
        const newEnabled = e.target.checked;
        setDialogOpen(true);
    }]])];
    return react.createElement(react.Fragment, {}, ...xs);
}

function Row(rowInputProps) {
    let elements, props_1, props_3, elems, elements_8, elements_7, elements_6, elems_7, children_4, children_2, elements_1, children_3;
    const company = rowInputProps.company;
    const onUpdate = rowInputProps.onUpdate;
    const key = rowInputProps.$key;
    const patternInput = reactApi.useState(false);
    const isOpen = patternInput[0];
    const xs = [MuiHelpers_createElement(TableRow, [["sx", {}], (elements = [MuiHelpers_createElement(TableCell, [["variant", "body"], ["sx", {
        borderBottom: (((0 + "px ") + "none") + " ") + "black",
    }], ["children", MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        patternInput[1](!isOpen);
    }], ["size", "small"], ["children", isOpen ? ((props_1 = {}, react.createElement(KeyboardArrowUp, props_1))) : ((props_3 = {}, react.createElement(KeyboardArrowDown, props_3)))]])]]), MuiHelpers_createElement(TableCell, [["variant", "body"], ["sx", {
        borderBottom: (((0 + "px ") + "none") + " ") + "black",
    }], ["children", company.Name]]), MuiHelpers_createElement(TableCell, [["variant", "body"], ["sx", {
        borderBottom: (((0 + "px ") + "none") + " ") + "black",
    }], (elems = toList(delay(() => (isNullOrWhiteSpace(company.Abbr) ? singleton_1(createElement(AbbrUpdateButton, {
        company: company,
        onUpdate: onUpdate,
    })) : singleton_1(company.Abbr)))), ["children", reactApi.Children.toArray(Array.from(elems))])]), MuiHelpers_createElement(TableCell, [["variant", "body"], ["sx", {
        borderBottom: (((0 + "px ") + "none") + " ") + "black",
    }], ["children", company.Database]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(TableRow, [["key", `${company.Id}-departments`], (elements_8 = [MuiHelpers_createElement(TableCell, [["colSpan", 5], ["style", {
        paddingTop: 0,
        paddingBottom: 0,
    }], (elements_7 = [MuiHelpers_createElement(Collapse, [["in", isOpen], (elements_6 = [MuiHelpers_createElement(Box, [["sx", {
        margin: 1,
    }], (elems_7 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Avdelinger"]]), (children_4 = ofArray([(children_2 = singleton(MuiHelpers_createElement(TableRow, [(elements_1 = [MuiHelpers_createElement(TableCell, [["children", "Id"]]), MuiHelpers_createElement(TableCell, [["children", "Navn"]]), MuiHelpers_createElement(TableCell, [["children", "Aktivert"]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_3 = map_1((department) => {
        let elements_3;
        return MuiHelpers_createElement(TableRow, [(elements_3 = [MuiHelpers_createElement(TableCell, [["children", department.Id]]), MuiHelpers_createElement(TableCell, [["children", department.Name]]), MuiHelpers_createElement(TableCell, [["children", createElement(EnableCheckboxDialog, {
            companyId: company.Id,
            departmentId: department.Id,
            onChange: (newEnabled) => {
                onUpdate(new Company(company.Id, company.Name, company.Database, company.Abbr, map_1((dep) => {
                    if (dep.Id === department.Id) {
                        return new Department(dep.Id, newEnabled, dep.Name);
                    }
                    else {
                        return dep;
                    }
                }, company.Departments)));
            },
            enabled: department.Enabled,
        })]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
    }, company.Departments), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_3))]]))]), MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_4))]]))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])], ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elements_7))])])], ["children", reactApi.Children.toArray(Array.from(elements_8))])])];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function Companies() {
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const responsive = useResponsive(undefined);
    const desktop = (responsive === "desktop") ? true : (responsive === "wideScreen");
    reactApi.useEffect(() => {
        const pr = Company_fetchCompanies();
        pr.then((arg_2) => {
            dispatch(new Message(1, [arg_2]));
        });
    }, []);
    const xs_3 = toList(delay(() => append_1(singleton_1(createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(4, []));
        },
    })), delay(() => append_1(model_1.AddForm ? singleton_1(createElement(AddForm, {
        onClose: (newDep) => {
            if (newDep != null) {
                dispatch(new Message(0, [newDep]));
            }
            else {
                dispatch(new Message(2, [false]));
            }
        },
    })) : empty_1(), delay(() => append_1(singleton_1(MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", ctx.Locale.t("Companies.Companies")]])), delay(() => {
        let elems_7, elems_6, elements_4, elems_5;
        return singleton_1(createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container"])], ["style", {
            height: ("calc(" + "100vh - 120px - 30px - 60px - 30px") + ")",
        }], (elems_7 = [createElement("div", createObj(ofArray([["className", join(" ", ["main-tab-container-inner", "admin-company-container"])], (elems_6 = [MuiHelpers_createElement(TableContainer, [["sx", createObj(toList(delay(() => (desktop ? singleton_1(["flexBasis", 800 + "px"]) : empty_1()))))], (elements_4 = toList(delay(() => {
            let children_3, children_1, children, children_2;
            const matchValue = model_1.Companies;
            if (matchValue != null) {
                const companies = matchValue;
                return singleton_1((children_3 = ofArray([(children_1 = singleton((children = ofArray([MuiHelpers_createElement(TableCell, []), MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("Account.Name")]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("Companies.Abbr")]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", "Database"]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_2 = map_1((company) => {
                    const $key14DC8325 = company.Id | 0;
                    return createElement(Row, {
                        key: $key14DC8325,
                        $key: $key14DC8325,
                        onUpdate: (arg_3) => {
                            dispatch(new Message(3, [arg_3]));
                        },
                        company: company,
                    });
                }, sortBy((d) => d.Database, companies, {
                    Compare: comparePrimitives,
                })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_2))]]))]), MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_3))]])));
            }
            else {
                const loadingIndicator = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                    width: 100 + "%",
                    height: 40,
                }]]);
                return append_1(singleton_1(loadingIndicator()), delay(() => append_1(singleton_1(loadingIndicator()), delay(() => singleton_1(loadingIndicator())))));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elements_4))])]), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["justifyContent", "space-between"]), delay(() => append_1(singleton_1(["alignItems", "center"]), delay(() => append_1(singleton_1(["alignSelf", "flex-start"]), delay(() => (desktop ? singleton_1(["flexBasis", 200 + "px"]) : empty_1()))))))))))))], (elems_5 = [createElement(Components_Button_Z1043B8E, {
            text: ctx.Locale.t("Companies.AddCompany"),
            onClick: (_arg_2) => {
                dispatch(new Message(2, [!model_1.AddForm]));
            },
            startIcon: (props_7) => {
                const props_9 = createObj(props_7);
                return react.createElement(Add, props_9);
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
    }))))))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

